<template>
<div :id="'upload-'+path" v-if="show">
	<script type="text/template" :id="'uploadtemplate-'+path">

		<div style="margin-bottom:5px">
			<div class="row">
        		<span class="name col-sm-3" data-dz-name></span>
 				<div class="col-sm-6">
        			<p class="size" data-dz-size></p>
        			<div class="progress progress-striped active" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
          				<div class="progress-bar progress-bar-success" style="width:0%;" data-dz-uploadprogress></div>
        			</div>
				</div>
				<div class="col-sm-3">
            		<button data-dz-remove class="btn btn-danger btn-sm cancel">
            			<i class="glyphicon glyphicon-minus"></i> {{$t('inputUpload.delete')}}
            		</button>
            		<span class="text-success success" style="display:none">
            			{{$t('inputUpload.success')}} <i class="glyphicon glyphicon-ok"></i>
            		</span>
            		<span class="text-danger error" style="display:none">
            			{{$t('inputUpload.fail')}} <i class="glyphicon glyphicon-warning-sign"></i>
            		</span>
				</div>
			</div>

        </div>
    </script>

	<div class="row">
		<div class="col-md-6">
			<div class="form-group">
				<label class="control-label col-md-2">{{$t('orderEdit.upload.category.'+path)}}</label>
				<div class="col-md-10">
					<div class="form-control-static">
						<table v-if="server_status === this.$cons.STATUS.DATA"
							class="table table-condensed">
								<tr v-for="(upload, index) in data" v-if="!collapse || index < 5">
									<td style="text-align: left;"><a
										:href="'order/order/downloadFile/?order='+ $route.params.id + '&file=' + upload.id">{{upload.filename}}
									</a></td>
									<td>{{upload.size}}</td>
									<td>{{upload.datetime}}</td>
									<td>{{upload.uploader}}</td>
									<td><template v-if="canDelete"> <a
											@click="deleteUpload(index)"> <span
											class="glyphicon glyphicon-trash" style="color: red"></span>
										</a> </template></td>
								</tr>
							<tr v-if="collapse && data.length > 5"><td><a class="own-tooltip" @click="collapse =!collapse"><i class="glyphicon glyphicon-chevron-down" /><span class="tooltiptext tooltip-top">Alle Dateien anzeigen</span></a></td><td colspan="4" /></tr>
							<tr v-if="!collapse"><td><a class="own-tooltip" @click="collapse =!collapse"><i class="glyphicon glyphicon-chevron-up" /><span class="tooltiptext tooltip-top">Dateien einklappen</span></a></td><td colspan="4" /></tr>
						</table>
		<!-- 				<ul v-if="server_status === this.$cons.STATUS.DATA"> -->
		<!-- 					<li v-for="(upload, index) in data" v-if="!collapse || index < 5"> -->
		<!-- 					<a :href="'order/order/downloadFile/?order='+ $route.params.id + '&file=' + upload.id">{{upload.filename}}</a> | -->
		<!-- 						{{upload.size}} | {{upload.datetime}} | {{upload.uploader}} <a v-if="canDelete"><i class="glyphicon glyphicon-trash" style="color:red"/></a></li> -->

		<!-- 					<li v-if="collapse && data.length > 0"><a class="own-tooltip" @click="collapse =!collapse"><i class="glyphicon glyphicon-chevron-down" /><span class="tooltiptext tooltip-top">Alle Dateien anzeigen</span></a></li>	 -->
		<!-- 					<li v-if="!collapse"><a class="own-tooltip" @click="collapse =!collapse"><i class="glyphicon glyphicon-chevron-up" /><span class="tooltiptext tooltip-top">Dateien einklappen</span></a></li>	 -->
		<!-- 				</ul> -->
					</div>

				</div>
			</div>
		</div>

		<div class="col-md-6">
			<div style="margin-top: 5px">
				<div class="panel panel-info">
					<div class="panel-heading text-center">
						<h4>{{$t('inputUpload.pull')}}</h4>
					</div>
					<div id="files" class="panel-body"></div>
				</div>
			</div>
		</div>
	</div>

</div>
</template>

<script>
import Dropzone from "dropzone"
import {capitalizeFirstLetter} from '@/javascript/misc.js'

export default {
  name: "UploadInput",
  data() {
    return {
    	myDropzone: null,
    	data: {},
    	show: this.$auth.hasPermission('upload'+capitalizeFirstLetter(this.path)),
    	canDelete: this.$auth.hasPermission('deleteUpload'+capitalizeFirstLetter(this.path)),
    	server_status: this.$cons.STATUS.LOADING,
    	collapse: true,
    };
  },
  props: ["path", "set", "value"],

  mounted() {
	  if(this.show) {
		this.createDropzone();
	  }
  },

  created() {
	  if(this.show) {
		this.$globals.getData(this, "order/order/uploadHistory/?order="+this.$route.params.id+"&path="+this.path);
	  }
  },

  methods: {
	  createDropzone() {
	  	var path = this.path;
        var preview = $('#uploadtemplate-' + path).html();
        this.myDropzone =  new Dropzone('#upload-'+ path + " .panel",{
	       url: this.set,
	       maxFilesize: 5000,
	       createImageThumbnails: false,
	       parallelUploads : 50,
	       previewTemplate : preview,
	       previewsContainer: '#upload-' + path + " .panel-body",
	       //autoQueue : false,
	       clickable : '#upload-'+ path + " .panel-heading",
	       headers: {
	           'xsrf-token': this.$auth.getCookieValue('xsrf-token')
	       },
           success: (file, response) => {
        	   let responseJSON = jQuery.parseJSON(response);
    	       file.previewElement.querySelector('.cancel').style.display='none';
               if(responseJSON.status) {
    	           file.previewElement.querySelector('.success').style.display='inline';
    	           this.data.unshift(responseJSON.file)
               } else {
                   file.previewElement.querySelector('.error').style.display='inline';
               }
           },
           error: (file, error, xhr) => {
        	  console.log(error);
        	  bootbox.alert("<b>"+this.$t('misc.errorOccured')+"</b>")
           }
        });
        this.myDropzone.on('sending', function(file, xhr, formData) {
            formData.append('path', path);
        });
	  },

	  deleteUpload(index) {
		  if(this.canDelete) {
		    bootbox.confirm(
	     		this.$t('clientList.deleteConfirmation', {name: this.data[index].filename}),
	 	   		result => {
	 	   			if(result === true) {
	 			   	 axios
	 			        .post("order/order/deleteUploadedFile/?order="+this.$route.params.id+"&file="+this.data[index].id)
	 			        .then(response => {
	 			        	if(response.data.status) {
	 			        		this.data.splice(index,1);
	 			        	}
	 			        });
	 	   			}
	 	   		}
	     	);
	     }
	  },

	  send() {
		  this.myDropzone.enqueueFiles(this.myDropzone.getFilesWithStatus(Dropzone.ADDED));
	  },
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/input/FileUploadInput.vue